export default {
  state: {
    countryList: []
  },
  getters: {
    getCountryList: state => {
      return state.countryList
    }
  },
  mutations: {
    setCountryList (state, res) {
      state.countryList = res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/country.js